import type { BroadcastProviderProps } from "./broadcast.type";

import { BroadcastContext } from "./broadcast.context";
import { useBroadcastInit } from "./broadcast.hook";

export const BroadcastProvider = ({ children }: BroadcastProviderProps) => {
  const pusher = useBroadcastInit();

  return (
    <BroadcastContext.Provider value={{ pusher }}>
      {children}
    </BroadcastContext.Provider>
  );
};
